// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_BACK_SUPPORT_POSITIONING_BUCKLE = "prackou";
export const STROLLER_BACK_SUPPORT_POSITIONING_BUTTON = "tla\u010didlom";
export const STROLLER_BACK_SUPPORT_POSITIONING_FRONT_RECLINE = "mechanizmom nakl\u00e1\u0148ania pod sedadlom";
export const STROLLER_BACK_SUPPORT_POSITIONING_REAR_RECLINE = "mechanizmom nakl\u00e1\u0148ania vzadu";
export const STROLLER_BACK_SUPPORT_POSITIONING_SIDE_HANDLES = "p\u00e1\u010dkami po bokoch";
export const STROLLER_BACK_SUPPORT_POSITIONING_SIDE_RECLINE = "mechanizmom nakl\u00e1\u0148ania po bokoch sedadla";
export const STROLLER_BACK_SUPPORT_POSITIONING_STRAP = "p\u00e1som";
export const STROLLER_BACK_SUPPORT_POSITIONING_ZIP = "zipsom";
export const STROLLER_BUMPER_BAR_TYPE_BAR = "ty\u010dov\u00e9";
export const STROLLER_BUMPER_BAR_TYPE_TRAY = "pultov\u00e9";
export const STROLLER_BUMPER_BAR_TYPE_T_SHAPED = "v tvare T";
export const STROLLER_CENTRAL_BRAKE_SYSTEM_HAND_OPERATED = "mechanizmus na r\u00fa\u010dke";
export const STROLLER_CENTRAL_BRAKE_SYSTEM_ONE_STEP_CRADLE_BRAKE = "n\u00e1\u0161\u013eapn\u00e1 kol\u00edskov\u00e1";
export const STROLLER_CENTRAL_BRAKE_SYSTEM_PUSH_LIFT = "n\u00e1\u0161\u013eapn\u00e1 stla\u010d/zdvihni";
export const STROLLER_CENTRAL_BRAKE_SYSTEM_PUSH_PUSH = "n\u00e1\u0161\u013eapn\u00e1 stla\u010d/stla\u010d";
export const STROLLER_FOLDING_SYSTEM_3D = "3D";
export const STROLLER_FOLDING_SYSTEM_FLAT = "na plocho";
export const STROLLER_FOLDING_SYSTEM_TELESCOPIC = "teleskopick\u00fd";
export const STROLLER_FOLDING_SYSTEM_UMBRELLA = "na d\u00e1\u017ednik";
export const STROLLER_HANDLE_ADJUSTMENT_PIVOTING = "oto\u010dn\u00e1";
export const STROLLER_HANDLE_ADJUSTMENT_TELESCOPIC = "teleskopick\u00e1";
export const STROLLER_MATERIAL_ALUMINIUM = "hlin\u00edk";
export const STROLLER_MATERIAL_CARBON = "karb\u00f3n";
export const STROLLER_MATERIAL_DURAL = "dural";
export const STROLLER_MATERIAL_FABRIC = "l\u00e1tka";
export const STROLLER_MATERIAL_FOAM = "pena";
export const STROLLER_MATERIAL_HARD_RUBBER = "tvrden\u00e1 guma";
export const STROLLER_MATERIAL_IRON = "\u017eelezo";
export const STROLLER_MATERIAL_LEATHER = "ko\u017ea";
export const STROLLER_MATERIAL_LEATHERETTE = "ko\u017eenka";
export const STROLLER_MATERIAL_MAGNESIUM = "hor\u010d\u00edk";
export const STROLLER_MATERIAL_METAL = "kov";
export const STROLLER_MATERIAL_PLASTIC = "plast";
export const STROLLER_MATERIAL_RECYCLED_PLASTIC = "recyklovan\u00fd plast";
export const STROLLER_MATERIAL_RESIN = "\u017eivica";
export const STROLLER_MATERIAL_RUBBER = "guma";
export const STROLLER_MATERIAL_SILICON = "silik\u00f3n";
export const STROLLER_MATERIAL_STEEL = "oce\u013e";
export const STROLLER_MATERIAL_WOOD = "drevo";
export const STROLLER_OR_CONJUNCTION = " alebo ";
export const STROLLER_SUSPENSION_ELASTOMERS = "elastom\u00e9rmi";
export const STROLLER_SUSPENSION_FRAME = "kon\u0161trukciou";
export const STROLLER_SUSPENSION_MECHANICAL = "mechanick\u00e9";
export const STROLLER_SUSPENSION_PNEUMATIC = "pneumatick\u00e9";
export const STROLLER_SUSPENSION_ROCKER = "vahadl\u00e1";
export const STROLLER_SUSPENSION_SPRING = "pru\u017einov\u00e9";
export const STROLLER_SUSPENSION_STRAPS = "remienky";
export const STROLLER_TYPE_2KOMBI = "dvojkombin\u00e1cia";
export const STROLLER_TYPE_3KOMBI = "trojkombin\u00e1cia";
export const STROLLER_TYPE_DEEP = "hlbok\u00fd";
export const STROLLER_TYPE_GOLF = "golfov\u00fd";
export const STROLLER_TYPE_MULTIKOMBI = "viackombi";
export const STROLLER_TYPE_PLATFORM = "podvozok";
export const STROLLER_TYPE_SIBLINGS = "s\u00farodeneck\u00fd";
export const STROLLER_TYPE_SIBLINGS_DOUBLE = "s\u00farodeneck\u00fd (double)";
export const STROLLER_TYPE_SIBLINGS_TANDEM = "s\u00farodeneck\u00fd (tandem)";
export const STROLLER_TYPE_SIBLINGS_TRIPLE = "s\u00farodeneck\u00fd (triple)";
export const STROLLER_TYPE_SPORTY = "\u0161portov\u00fd";
export const STROLLER_TYPE_TRAVEL_SYSTEM = "cestovn\u00fd syst\u00e9m";
export const STROLLER_WHEELS_ALL = "v\u0161etky";
export const STROLLER_WHEELS_FRONT = "predn\u00e9";
export const STROLLER_WHEELS_REAR = "zadn\u00e9";
export const STROLLER_WHEEL_TYPE_AIR_WHEELS = "nafukovacie pneumatiky";
export const STROLLER_WHEEL_TYPE_ARTIFICIAL_WHEELS = "nenafukovacie - umel\u00e9";
export const STROLLER_WHEEL_TYPE_FOAM_WHEELS = "pneumatiky plnen\u00e9 penou";
export const STROLLER_WHEEL_TYPE_GEL_WHEELS = "pneumatiky plnen\u00e9 g\u00e9lom";
